__turbopack_context__.v({
  "bottom": "_8CuwlW_bottom",
  "brand": "_8CuwlW_brand",
  "contact": "_8CuwlW_contact",
  "content": "_8CuwlW_content",
  "copy": "_8CuwlW_copy",
  "footer": "_8CuwlW_footer",
  "heading": "_8CuwlW_heading",
  "identity": "_8CuwlW_identity",
  "inner": "_8CuwlW_inner",
  "legal": "_8CuwlW_legal",
  "links": "_8CuwlW_links",
  "logo": "_8CuwlW_logo",
  "navigation": "_8CuwlW_navigation",
});
